import React from 'react'
import classNames from 'classnames'

export default function Card ({
  fullWidth,
  paddingBottom = true,
  transparent = false,
  purple = false,
  tight = false,
  overflow = null,
  className,
  children
}) {
  const _className = classNames(
    className,
    { 'rounded-lg': transparent === false },
    { 'bg-white': transparent === false && purple === false },
    { 'bg-primary-500': transparent === false && purple === true },
    { 'pt-10': tight === false },
    { 'pb-8': paddingBottom && tight === false },
    'flex flex-col',
    { 'overflow-hidden': overflow === 'hidden' },
    fullWidth ? 'full-width-card' : (tight === true ? '' : 'px-10')
  )

  return (
    <div className={_className}>
      {children}
    </div>
  )
}
